import SecureLS from "secure-ls";

class CustomLocalStorage implements Storage {
    [name: string]: any;
    length: number = 0; 
    private isProduction = true;
    private ls: SecureLS | null = new SecureLS();
    private static instance: CustomLocalStorage;
    
    private constructor() {
        this.isProduction = process.env.NODE_ENV === "production"; 
    } 

    public static getInstance(): CustomLocalStorage {
        if (!CustomLocalStorage.instance) {
            CustomLocalStorage.instance = new CustomLocalStorage();
        }

        return CustomLocalStorage.instance;
    }
    
    clear(): void {
        if (this.isProduction) {
            this.ls?.clear();

            return;
        }

        localStorage.clear();
    }

    getItem(key: string): string | null { 
        if (this.isProduction) {
            return this.ls?.get(key); 
        }

        return localStorage.getItem(key);
    }

    key(index: number): string | null {
        throw new Error("Method not implemented.");
    }

    removeItem(key: string): void {
        if (this.isProduction) {
            return this.ls?.remove(key);
        }

        return localStorage.removeItem(key);
    }

    setItem(key: string, value: string): void {
        if (this.isProduction) {
            return this.ls?.set(key, value)
        }

        return localStorage.setItem(key, value);
    }

    getPersistedStateConfig() {
        if (this.isProduction) {
            return {
                getItem: (key: any) => this.ls?.get(key),
                setItem: (key: any, value: any) => this.ls?.set(key, value),
                removeItem: (key: any) => this.ls?.remove(key)
            }
        }

        return undefined;
    }
}

export default CustomLocalStorage.getInstance();